export const environment = {
  production: true,
  hostName: 'api-lesainesenfete.laval.fr',
  protocol: 'https',
  nbLimitPreInscription: 500,
  nbLimitTotalInscription: 1000
};
